import { TableInstance } from 'react-table';
import { PageSizeSelector } from '~components/ui/PageSizeSelector';
import { Pagination } from '~components/ui/Pagination';
import { DisplayTable_DisplayFragment } from './__generated__/DisplayTable.graphql';

export function DisplayTablePagination({
  table,
}: {
  table: TableInstance<DisplayTable_DisplayFragment>;
}) {
  const {
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    gotoPage,
    state: { pageIndex },
    pageCount,
  } = table;

  return (
    <Pagination
      pageCount={pageCount}
      currentPageIndex={pageIndex}
      hasPreviousPage={canPreviousPage}
      hasNextPage={canNextPage}
      goToPage={gotoPage}
      goToPreviousPage={previousPage}
      goToNextPage={nextPage}
    />
  );
}

export function DisplayTablePageSizeSelector({
  table,
  sizes,
}: {
  table: TableInstance<DisplayTable_DisplayFragment>;
  sizes?: number[];
}) {
  const {
    state: { pageSize },
    setPageSize,
  } = table;

  return (
    <PageSizeSelector
      label="displays per page"
      onChange={setPageSize}
      options={sizes}
      value={pageSize}
    />
  );
}
